module.exports = __webpack_public_path__ + "static/media/receiver-img.f0c0fc71.jpg";